(() => {
  const node = document.getElementById('trexo-campaign-config');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  if (!config.enabled) return;
  const start = Date.parse(config.startsAt);
  const end = Date.parse(config.endsAt);
  const refreshAtBoundary = () => {
    const now = Date.now();
    const active = now >= start && now < end;
    if (active !== config.active) {
      // Refresh all variant prices and announcement together at either boundary.
      const key = `trexo-campaign-${config.endsAt}-${active}`;
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, '1');
        window.location.reload();
      }
    }
  };
  [start, end].forEach((boundary) => {
    const delay = boundary - Date.now();
    if (delay >= 0 && delay < 2147483000) setTimeout(refreshAtBoundary, delay + 1000);
  });
  window.addEventListener('pageshow', refreshAtBoundary);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refreshAtBoundary();
  });
  refreshAtBoundary();
})();
